var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontWeights, Separator, Stack, Text } from "@fluentui/react";
import { useEffect } from "react";
import { Link } from "./components/common/Link";
import { appConfigs } from "./utils/appConfigs";
import { useClasses } from "./utils/useClasses";
var getClasses = function (theme) { return ({
    root: {
        borderTop: "16px",
        borderColor: theme.palette.orangeLighter,
        paddingTop: "20vh",
    },
    container: {
        padding: "16px 20px 24px 20px",
        backgroundColor: theme.palette.white,
        boxShadow: theme.effects.elevation8,
        maxWidth: "100%",
        width: "360px",
    },
    h1: {
        color: theme.palette.black,
    },
    h2: {
        color: theme.palette.orangeLighter,
        fontWeight: FontWeights.bold,
        marginBottom: "8px",
    },
}); };
var tokens = {
    container: {
        childrenGap: 24,
    }
};
export var FourOFour = function (props) {
    var classes = useClasses(getClasses);
    useEffect(function () {
        document.title = "Error: 404";
    });
    return _jsx(Stack, __assign({ className: classes.root, horizontalAlign: "center" }, { children: _jsxs(Stack, __assign({ className: classes.container, tokens: tokens.container }, { children: [_jsxs(Stack, { children: [_jsx(Text, __assign({ className: classes.h2, variant: "large" }, { children: "404" }), void 0), _jsx(Text, __assign({ className: classes.h1, variant: "xLarge" }, { children: "Page Not Found" }), void 0), _jsx(Separator, {}, void 0), _jsx(Text, { children: "The specified file was not found on this website. Please check the URL for mistakes and try again." }, void 0)] }, void 0), props.children &&
                    _jsxs(Stack, { children: [_jsx(Text, __assign({ className: classes.h1, variant: "xLarge" }, { children: "Useful Resources" }), void 0), _jsx(Separator, {}, void 0), props.children, _jsxs(Text, { children: ["Still can't find what you're looking for? Feel free to leave a message ", _jsx(Link, __assign({ href: appConfigs.contacts.defaultMessage }, { children: "here" }), void 0), "."] }, void 0)] }, void 0)] }), void 0) }), void 0);
};
//# sourceMappingURL=404.js.map